// src/pages/Contact.jsx
import { useState } from 'react';
import SectionTitle from '../components/common/SectionTitle';
import Button from '../components/common/Button';
import contactBg from '../Assets/TeamandOthers/Reception.webp';

const branches = [
  {
    city: "VIJAYAWADA",
    name: "Dr. Sridhar International Dental Hospital",
    address: "Vijaya talkies Centre, Eluru Road, VIJAYAWADA-520002",
    email: "dr.sridhardental@gmail.com",
    phones: ["0866-2432011", "2435011", "9490948081"],
    extraContacts: [
      { label: "EHS & ABS Enquiry", name: "Samuel John", phone: "9553831831" },
      { label: "Orthodontic Enquiry", phone: "0866-2432011, 9553295938" },
      { label: "Emergency (Natraj)", phone: "9963036436" },
      { label: "Emergency (Eswar Reddy)", phone: "9705650999" },
    ],
    mapUrl: "https://www.google.com/maps/dir//Dr.+Sridhar+International+Dental+Hospital+Vijayawada",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.264104043141!2d80.6291667758925!3d16.512709984611596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35efcc00000001%3A0x6a6a9b43e8d7f6c!2sDr.%20Sridhar%20International%20Dental%20Hospital!5e0!3m2!1sen!2sin!4v1709123456790!5m2!1sen!2sin"
  },
  {
    city: "KPHB HYDERABAD",
    name: "Dr. Sridhar International Dental Hospital",
    address: "Opposite JNTU, KPHB, HYDERABAD-500072",
    email: "jntu@sridhardental.com",
    phones: ["8121 222 666", "8121 222 888", "812 59 22 666"],
    mapUrl: "https://www.google.com/maps/dir//Dr.+Sridhar+International+Dental+Hospital+KPHB",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.215233216839!2d78.38865667591323!3d17.4972620834094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918eb2957b9d%3A0xe54d89613149ec96!2sDr.%20Sridhar%20International%20Dental%20Hospital!5e0!3m2!1sen!2sin!4v1709123456789!5m2!1sen!2sin"
  },
  
  {
    city: "AMEERPET",
    name: "Dr. Sridhar International Dental Hospital",
    address: "Opposite Big Bazaar, AMEERPET, HYDERABAD-500016",
    email: "ameerpet@sridhardental.com",
    phones: ["040-66611166", "23417265", "81216 66111"],
    mapUrl: "https://www.google.com/maps/dir//Dr.+Sridhar+International+Dental+Hospital+Ameerpet",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.666!2d78.446!3d17.432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90c88aaaaaab%3A0x1234567890abcdef!2sDr.%20Sridhar%20International%20Dental%20Hospital%20Ameerpet!5e0!3m2!1sen!2sin!4v1709123456791!5m2!1sen!2sin"
  },
  {
    city: "NALLAGANDLA (BHEL)",
    name: "Dr. Sridhar International Dental Hospital",
    address: "Plot 230, VMS Arcade, 1st Floor, Nallagandla, Hyderabad-500019",
    email: "nallagandla@sridhardental.com",
    phones: ["954 202 7700"],
    mapUrl: "https://www.google.com/maps/dir//Dr.+Sridhar+International+Dental+Hospital+Nallagandla",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.864!2d78.312!3d17.472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb930000000001%3A0xabcdef123456789!2sDr.%20Sridhar%20International%20Dental%20Hospital%20Nallagandla!5e0!3m2!1sen!2sin!4v1709123456792!5m2!1sen!2sin"
  }
];

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === 'phone') {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData(prev => ({ ...prev, [id]: numericValue }));
    } else {
      setFormData(prev => ({ ...prev, [id]: value }));
    }
    if (errors[id]) {
      setErrors(prev => ({ ...prev, [id]: '' }));
    }
  };

  const validate = () => {
    let newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!formData.name.trim()) newErrors.name = "Full name is required";
    
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format (e.g. abc@gmail.com)";
    }

    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Phone number must be 10 digits";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "Invalid Indian mobile number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setIsSubmitting(true);
      setTimeout(() => {
        setIsSubmitting(false);
        alert("Thank you! Your message has been sent. We'll get back to you soon.");
        setFormData({ name: '', email: '', phone: '', message: '' });
      }, 1500);
    }
  };

  return (
    <main className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative text-white py-24 md:py-32 bg-cover bg-center" style={{ backgroundImage: `url(${contactBg})` }}>
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-black/60"></div>
        <div className="relative container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4">Contact Us</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto leading-relaxed">
            World-class dental healthcare across Hyderabad and Vijayawada. Reach out to your nearest branch today.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            
            {/* Left: Contact Form (Sticky) */}
            <div className="lg:col-span-5">
              <div className="bg-white p-8 md:p-10 rounded-3xl shadow-2xl border border-gray-100 sticky top-24">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">Book an Appointment</h2>
                <p className="text-gray-500 mb-8">Please fill in your details and our team will contact you shortly.</p>
                
                <form onSubmit={handleSubmit} className="space-y-5" noValidate>
                  <div className="space-y-1">
                    <label className="text-sm font-semibold text-gray-700 ml-1">Full Name *</label>
                    <input 
                      id="name"
                      type="text" 
                      value={formData.name}
                      onChange={handleChange}
                      className={`w-full px-5 py-4 bg-gray-50 border rounded-2xl focus:ring-2 outline-none transition-all ${errors.name ? 'border-red-500 focus:ring-red-100' : 'border-gray-200 focus:ring-blue-500'}`} 
                      placeholder="Your Full Name" 
                    />
                    {errors.name && <p className="text-red-500 text-xs ml-1">{errors.name}</p>}
                  </div>
                  
                  <div className="space-y-1">
                    <label className="text-sm font-semibold text-gray-700 ml-1">Email Address *</label>
                    <input 
                      id="email"
                      type="email" 
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-full px-5 py-4 bg-gray-50 border rounded-2xl focus:ring-2 outline-none transition-all ${errors.email ? 'border-red-500 focus:ring-red-100' : 'border-gray-200 focus:ring-blue-500'}`} 
                      placeholder="example@mail.com" 
                    />
                    {errors.email && <p className="text-red-500 text-xs ml-1">{errors.email}</p>}
                  </div>

                  <div className="space-y-1">
                    <label className="text-sm font-semibold text-gray-700 ml-1">Phone Number *</label>
                    <div className="relative">
                      <span className="absolute left-4 top-4 text-gray-400 font-medium">+91</span>
                      <input 
                        id="phone"
                        type="tel" 
                        value={formData.phone}
                        onChange={handleChange}
                        className={`w-full pl-14 pr-5 py-4 bg-gray-50 border rounded-2xl focus:ring-2 outline-none transition-all ${errors.phone ? 'border-red-500 focus:ring-red-100' : 'border-gray-200 focus:ring-blue-500'}`} 
                        placeholder="10-digit number" 
                      />
                    </div>
                    {errors.phone && <p className="text-red-500 text-xs ml-1">{errors.phone}</p>}
                  </div>

                  <div className="space-y-1">
                    <label className="text-sm font-semibold text-gray-700 ml-1">Message</label>
                    <textarea 
                      id="message"
                      rows={4} 
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none transition-all resize-none" 
                      placeholder="How can we help you?"
                    ></textarea>
                  </div>

                  <Button 
                    type="submit" 
                    disabled={isSubmitting} 
                    className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl font-bold text-lg shadow-lg transition-all flex justify-center items-center gap-2"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Sending...
                      </>
                    ) : "Send Message"}
                  </Button>
                </form>
              </div>
            </div>

            {/* Right: Branches Column */}
            <div className="lg:col-span-7 space-y-10">
              {branches.map((branch, index) => (
                <div key={index} className="bg-white rounded-[2rem] overflow-hidden shadow-xl border border-gray-100 flex flex-col group hover:shadow-2xl transition-all duration-300">
                  
                  {/* Google Map Embed */}
                  <div className="w-full h-64 bg-gray-200 relative">
                    <iframe
                      title={`${branch.city} map`}
                      src={branch.embedUrl}
                      className="w-full h-full border-0"
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>

                  <div className="p-8 md:p-10">
                    <div className="flex flex-col md:flex-row justify-between items-start gap-4 mb-6">
                      <div>
                        <span className="inline-block px-4 py-1 bg-blue-50 text-blue-600 text-xs font-bold rounded-full uppercase tracking-widest mb-2">
                          {branch.city} Branch
                        </span>
                        <h3 className="text-2xl font-bold text-gray-800">{branch.name}</h3>
                      </div>
                      <a 
                        href={branch.mapUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 rounded-xl font-semibold text-sm hover:bg-blue-700 transition-colors shadow-md"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                        Get Directions
                      </a>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm">
                      <div className="space-y-4">
                        <div className="flex gap-4">
                          <span className="text-xl">📍</span>
                          <p className="text-gray-600 leading-relaxed font-medium">{branch.address}</p>
                        </div>
                        <div className="flex gap-4">
                          <span className="text-xl">✉️</span>
                          <a href={`mailto:${branch.email}`} className="text-blue-600 font-bold hover:underline break-all">
                            {branch.email}
                          </a>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div className="flex gap-4">
                          <span className="text-xl">📞</span>
                          <div className="flex flex-col gap-1">
                            {branch.phones.map((p, i) => (
                              <a key={i} href={`tel:${p.replace(/\s/g, '')}`} className="text-gray-800 font-bold hover:text-blue-600 transition-colors">
                                {p}
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Extra Enquiry Section for Vijayawada (and others if added) */}
                    {branch.extraContacts && (
                      <div className="mt-8 pt-8 border-t border-gray-100">
                        <h4 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-4">Special Enquiries & Management</h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          {branch.extraContacts.map((extra, idx) => (
                            <div key={idx} className="bg-gray-50 p-3 rounded-xl border border-gray-100">
                              <p className="text-[10px] font-bold text-blue-600 uppercase mb-1">{extra.label}</p>
                              <p className="text-sm font-bold text-gray-800">
                                {extra.name && <span className="text-gray-500 font-normal">{extra.name}: </span>}
                                {extra.phone}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {/* Working Hours Card */}
              <div className="bg-gradient-to-br from-gray-900 to-blue-900 rounded-[2rem] p-8 md:p-12 text-white flex flex-col md:flex-row justify-between items-center gap-8">
                <div className="text-center md:text-left">
                  <h4 className="text-3xl font-bold mb-2">Hospital Timings</h4>
                  <p className="text-blue-200 text-lg">Mon – Sat: <span className="text-white font-bold">9:00 AM – 9:00 PM</span></p>
                  <p className="text-blue-300 text-sm mt-2 font-medium italic">* Emergency services available 24/7 at selected branches.</p>
                </div>
                <div className="h-20 w-px bg-white/20 hidden md:block"></div>
                <div className="text-center">
                  <p className="text-sm uppercase tracking-widest text-blue-300 mb-1">Total Branches</p>
                  <p className="text-5xl font-black">04</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;